import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

const ShipDesignNavalArchitecture = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="service-hero">
        <div className="service-cover-text-ship">
          <h1>Ship Design, Naval Architecture Services & Boat Building</h1>
          <p>Precision Marine Engineering, 3D CAD Modeling & Custom Vessel Construction</p>
        </div>
      </section>

      {/* Featured Infographic Showcase Banner matching Reference Design */}
      <section className="naval-architecture-showcase-section">
        <div className="naval-architecture-container">
          <div className="naval-blueprint-card">
            {/* Background Grid Pattern Overlay */}
            <div className="blueprint-grid-overlay"></div>
            
            {/* Header Content */}
            <div className="naval-card-header">
              <span className="naval-badge-subtitle">BLUE WAVES MARITIME ENGINEERING</span>
              <h2>SHIP DESIGN & NAVAL ARCHITECTURE SERVICES</h2>
              <p className="naval-card-desc">
                We provide naval architecture, marine design, and boat-building solutions tailored to your operational requirements. From concept and engineering design to construction, modification, and delivery, our team supports the development of steel and aluminum vessels, workboats, barges, crew boats, supply boats, and tugboats with a focus on quality, safety, and performance.
              </p>
            </div>

            {/* Top Workflow Process Badges */}
            <div className="naval-process-badges">
              <div className="naval-process-badge">
                <div className="badge-icon">🚢</div>
                <span>CONCEPT DESIGN</span>
              </div>
              <div className="naval-process-badge">
                <div className="badge-icon">🧊</div>
                <span>3D MODELING</span>
              </div>
              <div className="naval-process-badge">
                <div className="badge-icon">📐</div>
                <span>NAVAL ARCHITECTURE</span>
              </div>
              <div className="naval-process-badge">
                <div className="badge-icon">⚙️</div>
                <span>DETAIL DESIGN</span>
              </div>
            </div>

            {/* Main Visual & Key Highlights Layout */}
            <div className="naval-showcase-grid">
              {/* Left Side Feature Badges */}
              <div className="naval-highlights-column">
                <div className="naval-highlight-badge">
                  <div className="highlight-icon">📐</div>
                  <div className="highlight-text">
                    <h4>ACCURATE DESIGN & CALCULATIONS</h4>
                    <p>Hydrostatics, stability, CFD hull resistance, and structural finite element analysis (FEA).</p>
                  </div>
                </div>

                <div className="naval-highlight-badge">
                  <div className="highlight-icon">🛡️</div>
                  <div className="highlight-text">
                    <h4>CLASS & REGULATION COMPLIANT</h4>
                    <p>Full approval and compliance with major Classification Societies (IACS, IMO, SOLAS, MARPOL).</p>
                  </div>
                </div>

                <div className="naval-highlight-badge">
                  <div className="highlight-icon">📦</div>
                  <div className="highlight-text">
                    <h4>EFFICIENT, SAFE & COST OPTIMIZED</h4>
                    <p>Streamlined hull geometry for fuel efficiency, vessel safety, and reduced lifecycle costs.</p>
                  </div>
                </div>
              </div>

              {/* Center / Right 3D Blueprint Animated Image */}
              <div className="naval-blueprint-visual-wrapper">
                <div className="blueprint-image-frame">
                  <img
                    src="/images/ship-design-blueprint.webp"
                    alt="Ship Design & Naval Architecture Blueprint Schematics"
                    className="blueprint-img-animated"
                  />
                  <div className="blueprint-scanline"></div>
                </div>
              </div>
            </div>

            {/* Vessel Types Supported Pills */}
            <div className="naval-vessels-supported">
              <h3>Vessels We Design & Build</h3>
              <div className="vessel-chips">
                <span className="chip">Steel & Aluminum Vessels</span>
                <span className="chip">Workboats</span>
                <span className="chip">Barges</span>
                <span className="chip">Crew Boats</span>
                <span className="chip">Supply Boats</span>
                <span className="chip">Tugboats</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Deep Dive Details Section */}
      <section className="service-intro">
        <div className="content">
          <h2>End-to-End Naval Architecture & Construction Solutions</h2>
          <p>
            Blue Waves Ship Management combines deep maritime engineering expertise with modern 3D CAD design technologies to deliver turnkey naval architecture solutions. Whether you require new vessel design, hull modification, stability re-assessment, or full-scale boat building supervision, our naval architects ensure your project meets strict international marine standards.
          </p>
        </div>
      </section>

      <section className="service-section">
        <div className="service-split">
          <div className="text">
            <h3>⚙️ Comprehensive Scope of Services</h3>
            <ul>
              <li><strong>Concept & Feasibility Studies:</strong> Initial vessel sizing, speed-power estimation, and operational payload optimization.</li>
              <li><strong>3D CAD Modeling & General Arrangement:</strong> Detailed 3D hull modeling, compartmentation, and deck layout designs.</li>
              <li><strong>Structural & Hull Engineering:</strong> Midship section calculations, finite element stress analysis (FEA), and weight estimation.</li>
              <li><strong>Stability & Hydrodynamics:</strong> Intact and damage stability booklets, inclining experiments, and hydrodynamic resistance analysis.</li>
              <li><strong>Boat Building & Construction Supervision:</strong> On-site shipyard oversight, steel/aluminum fabrication control, and sea trials validation.</li>
            </ul>
          </div>
          <div className="image">
            <img src="/images/ship-design-blueprint.webp" alt="Naval Architecture 3D CAD Blueprint" />
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="service-cta">
        <h2>Discuss Your Ship Design & Boat Building Project</h2>
        <p>Partner with experienced naval architects and marine engineers to bring your vessel concept to reality with precision and performance.</p>
        <a href="/contact" className="cta-button">Get in Touch</a>
      </section>

      <Footer />
    </div>
  );
};

export default ShipDesignNavalArchitecture;
